<template>
  <v-container>
    <h1>User Settings</h1>
    <v-row class="mt-4">
      <v-col cols="6" sm="3" class="py-0">
        <v-text-field
          v-model="userSearch"
          label="Search"
          single-line
          outlined
          color="#273896"
        ></v-text-field>
      </v-col>
      <!-- <v-col cols="2" md="2" sm="2" xs="2" class="pb-0 py-0 px-0">
            <v-btn large depressed color="#2C3B97"  class="search-button white--text pa-0">Search</v-btn>
        </v-col> -->
      <v-col cols="10" md="9" sm="9" xs="9" class="pb-0 py-0 text-right">
        <v-btn
          color="#2C3B97"
          large
          outlined
          class="add-user"
          @click="addUser()"
        >
          <v-icon>mdi-plus</v-icon> Add New User</v-btn
        >
      </v-col>
    </v-row>
    <v-row class="my-0">
      <v-col cols="12" class="py-0 manageuser-table">
        <v-data-table
          disable-sort
          :headers="headers"
          :page.sync="page"
          :items="userResponse"
          item-key=""
          :search="userSearch"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:item.sts="{ item }">
            <span v-bind:class="getClass(item.stsCode)">
              {{ item.sts }}
            </span>
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn
              text
              small
              @click="editUser(item)"
              color="#2C3B97"
              class="px-1"
              >Edit</v-btn
            ></template
          >
        </v-data-table>
      </v-col>
      <v-col cols="12" class="py-0">
        <v-pagination
          v-model="page"
          :length="pageCount"
          color="#2C3B97"
        ></v-pagination>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// @ts-ignore
import ManageUser from "./manageUser.ts";
export default ManageUser;
</script>

<style lang="css" src="./manageUser.css" scoped />